const __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"https://vetan.ethiq.io:6021"};